import type { HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  elevated?: boolean;
}

/**
 * Carbon-style card primitive: flat, hairline-bordered tile.
 * `elevated` swaps the canvas background for surface-1 (used for
 * "recommended"/highlighted tiles) — hierarchy is carried by surface
 * change, not shadow.
 */
export function Card({ elevated = false, className = "", children, ...props }: CardProps) {
  return (
    <div
      className={`rounded-none border border-[var(--hairline)] p-6 ${
        elevated ? "bg-[var(--bg-hover)]" : "bg-[var(--bg-card)]"
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
